import { useContext } from "react";
import { JointBillContext } from "@features/JointBillList/utils";
import { Skeleton } from "@components/Skeleton/Skeleton";

export const ProviderBillTotalCellSkeleton: React.FC = () => {
  const { isSummaryMode } = useContext(JointBillContext);

  return (
    <div className="relative mt-3 flex flex-col items-end gap-3.5 md:mt-0">
      <div className="flex items-center gap-4">
        <div className="flex gap-4">
          <div className="flex gap-2">
            <Skeleton className="text-md w-20" />
          </div>
        </div>
        {!isSummaryMode && <Skeleton className="h-5 w-5" />}
      </div>
      {!isSummaryMode && <Skeleton className="h-2.5 w-5 md:hidden" />}
    </div>
  );
};
